const DefinitionMapper = {
  revenue: `Income generated from a council's activities.`,
  ratesAndAnnualCharges: null,
  userChargesAndFees: null,
  interestAndInvestmentRevenue: null,
  otherRevenue: null,
  grantsAndContributionsProvidedForOperating: null,
  grantsAndContributionsProvidedForCapital: null,
  netGainsFromTheDisposalsOfAssets: null,
  NetShareOfInterestsInJointVenturesAndAssociates: null,
  expenses: `Payments required to deliver a council's activities.`,
  employeeBenefitsAndOnCosts: null,
  borrowingCosts: null,
  materialsAndContracts: null,
  depreciationAndAmortisation: null,
  impairment: null,
  otherExpenses: null,
  netLossesFromDisposalOfAssets: null,
  operatingResult:
    'Operating surplus or deficit after expenses are deducted from revenue. Excludes the impact of extraordinary events such as amalgamations and boundary adjustments.',
  assets: `A resource a council controls that will provide a future benefit (for example, cash, land and buildings).`,
  currentAssets:
    'An asset that is available for use, or is expected to be consumed in a short time, usually 12 months (e.g. cash).',
  nonCurrentAssets:
    'An asset that is not a current asset (e.g. land and buildings)',
  liabilities: `A council's obligations to make future payments (for example, payables, borrowings and employee entitlements).`,
  currentLiabilities:
    'A liability that may be required to be settled in a short time, usually 12 months (e.g. payables due in 30 days).',
  nonCurrentLiabilities:
    'A liability that is not a current liability (e.g. long term borrowings).',
  operatingPerformance:
    'How well councils keep operating expenses within operating revenue. The Office of Local Government (OLG) sets a benchmark greater than zero per cent for this measure. ',
  ownSourceOperatingRevenue:
    'Degree to which a Council relies on external funding sources. More than 60 per cent of total revenue is the OLG benchmark. ',
  unrestrictedCurrentRatio:
    'councils ability to meet its short-term obligations as they fall due. OLG sets a benchmark of greater than 1.5 times.',
  debtServiceCoverRatio:
    "Operating cash available to service a council's debt. OLG benchmark is to have cash greater than twice the amount required to service debt.",
  ratesAndAnnualChargesOutstandingPercentage:
    '% of rates and annual charges unpaid as at 30 June. OLG benchmark - <5% (metropolitan councils) and <10% (regional & rural councils)',
  cashExpenseCoverRatio:
    'Number of months a Council can continue paying its expenses without extra cash. OLG sets a benchmark at >3 months for this ratio.',
};

export default DefinitionMapper;



// WEBPACK FOOTER //
// ./src/helpers/definition-mapper.js